import { getSanityImageSrcSet, getSanityImageUrl, type Env } from '@fff-web/constants';
import env from './env';

/**
 * Builds a Sanity image URL served from our own CDN and sized to how the
 * image is actually rendered.
 *
 * Product/box images reach us from the Growth and Box APIs as fully-formed
 * URLs. When they point at `cdn.sanity.io` they bypass our CloudFront and
 * transfer the full-size original; URLs on any other host (e.g. scontent) are
 * returned unchanged.
 * @param src - Image URL supplied by the API.
 * @param width - Rendered CSS width in px.
 * @returns The CDN URL, or an empty string when src is missing.
 */
export const sanityImage = (src?: string | null, width?: number): string =>
  getSanityImageUrl(src, env.env as Env, { width });

/**
 * `srcSet` companion to {@link sanityImage}, covering 1x-3x displays.
 * @param src - Image URL supplied by the API.
 * @param width - Rendered CSS width in px.
 * @returns A srcSet string, or undefined when the image is not a Sanity image.
 */
export const sanityImageSrcSet = (src?: string | null, width?: number): string | undefined =>
  getSanityImageSrcSet(src, env.env as Env, { width });
